import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLang, useTenant } from "../hooks";
import { NavLink } from "react-router-dom";
import { useApps } from "../data/sidebaricons";
import { FiLogOut } from "react-icons/fi";
import { FaChevronUp } from "react-icons/fa";
import { FaFileInvoiceDollar } from "react-icons/fa";
import { userHasAppAccess } from "../utils/appAccess";

const MenuSide = () => {
  const { sidebarIcons, loadingApps } = useApps();
  const _token = localStorage.getItem("token");
  const userRaw = localStorage.getItem("user");
  const userApps = useMemo(() => {
    if (!userRaw) return [];
    try {
      const parsedUser = JSON.parse(userRaw);
      return Array.isArray(parsedUser?.my_apps) ? parsedUser.my_apps : [];
    } catch {
      return [];
    }
  }, [userRaw]);
  const user = useMemo(() => {
    if (!userRaw) return null;
    try {
      return JSON.parse(userRaw);
    } catch {
      return null;
    }
  }, [userRaw]);
  const { langSelected } = useLang();
  const { tenantUsername } = useTenant();
  const tenantFromPath = window.location.pathname.split("/").filter(Boolean)[0];
  const tenantForRoute = tenantUsername || tenantFromPath;
  const scrollContainerRef = useRef(null);
  const [sideicon, setSideicon] = useState([]);
  const [hoverTooltip, setHoverTooltip] = useState(null);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const tooltipHideTimeoutRef = useRef(null);
  const canViewVatFilingReport = userHasAppAccess(user, sidebarIcons, "sales")
    && userHasAppAccess(user, sidebarIcons, "purchases");

  useEffect(() => {
    if (!sidebarIcons || loadingApps) return;
    const filteredIcons = sidebarIcons
      .filter((app) => userApps.includes(app.id || app._id))
      .reverse();
    setSideicon(filteredIcons);
  }, [userApps, sidebarIcons, loadingApps]);

  const scrollMenu = (direction) => {
    const el = scrollContainerRef.current;
    if (!el) return;
    const scrollAmount = direction === "up" ? -120 : 120;
    el.scrollBy({ top: scrollAmount, behavior: "smooth" });
  };

  const setTooltipFromElement = (title, element) => {
    if (!title) return;
    if (tooltipHideTimeoutRef.current) {
      clearTimeout(tooltipHideTimeoutRef.current);
      tooltipHideTimeoutRef.current = null;
    }
    const rect = element.getBoundingClientRect();
    const isRTL = langSelected.value === "ar";
    setIsTooltipVisible(false);
    setHoverTooltip({
      title,
      top: rect.top,
      height: rect.height,
      isRTL,
      left: rect.right,
      right: window.innerWidth - rect.left,
    });
    requestAnimationFrame(() => setIsTooltipVisible(true));
  };

  const onItemEnter = (title) => (e) =>
    setTooltipFromElement(title, e.currentTarget);
  const onItemLeave = () => {
    setIsTooltipVisible(false);
    tooltipHideTimeoutRef.current = setTimeout(() => {
      setHoverTooltip(null);
      tooltipHideTimeoutRef.current = null;
    }, 180);
  };

  return (
    <div className="z-50 fixed md:top-20 bottom-[5%] start-0 w-10 flex flex-col items-center justify-between overflow-visible h-[70%] md:h-[80%]">
      <div
        className="cursor-pointer w-8 h-8 flex items-center justify-center rounded-md text-white hover:text-indigo-200 sticky top-0"
        onClick={() => scrollMenu("up")}
      >
        <FaChevronUp size={16} />
      </div>
      <div
        ref={scrollContainerRef}
        className="no-scrollbar overflow-y-auto overflow-x-visible flex-1 min-h-0 w-full flex flex-col items-center"
      >
        <ul className="list-none m-0 p-0 py-2 flex flex-col gap-3 items-center text-white text-xs w-full">
          {sideicon?.map((app, index) => {
            const appTitle =
              langSelected.value === "ar" ? app?.titleAr : app?.titleEn;
            const isDone = app.status === "done";
            return (
              <li
                key={index}
                data-title={appTitle}
                className={
                  isDone
                    ? "w-full relative tooltip sidebar-item flex justify-center items-center"
                    : "w-full relative tooltip sidebar-item flex justify-center items-center not-allow"
                }
                onMouseEnter={onItemEnter(appTitle)}
                onMouseLeave={onItemLeave}
              >
                <NavLink
                  to={
                    isDone && tenantForRoute && _token
                      ? `${app.baseUrl}/${tenantForRoute}/token/${_token}`
                      : "not-allowd"
                  }
                  className={
                    isDone
                      ? "z-20 w-full flex items-center justify-center py-3"
                      : "z-20 w-full flex items-center justify-center py-3 cursor-not-allowed"
                  }
                >
                  <img
                    src={app?.icon}
                    alt={appTitle}
                    className={`${isDone
                      ? "w-6 transition-all"
                      : "w-6 transition-all opacity-45"
                      } filter p-[1px] invert brightness-0`}
                  />
                </NavLink>
                <span></span>
              </li>
            );
          })}
          {/*
            <li
              data-title={langSelected.value === "ar" ? "تسجيل الخروج" : "Logout"}
              className="w-full relative tooltip sidebar-item mt-6 flex justify-center items-center"
              onMouseEnter={onItemEnter(
                langSelected.value === "ar" ? "تسجيل الخروج" : "Logout"
              )}
              onMouseLeave={onItemLeave}
            >
              <NavLink
                to={tenantForRoute ? `/${tenantForRoute}/logout` : "/notfound"}
                className="z-20 w-full flex items-center justify-center py-3"
              >
                <FiLogOut className="w-6 h-6" />
              </NavLink>
              <span></span>
            </li>
          */}
        </ul>
          {/* VAT Filing Report Static Item */}
          {canViewVatFilingReport && (
          <li
            data-title={langSelected.value === "ar" ? "الإقرار الضريبي" : "VAT Filing Report"}
            className="w-full relative tooltip sidebar-item flex justify-center items-center"
            onMouseEnter={onItemEnter(langSelected.value === "ar" ? "الإقرار الضريبي" : "VAT Filing Report")}
            onMouseLeave={onItemLeave}
          >
            <NavLink
              to={tenantForRoute ? `/${tenantForRoute}/vat-filing-report` : "/notfound"}
              className="z-20 w-full flex items-center justify-center py-3"
            >
              <FaFileInvoiceDollar className="w-6 h-6 text-white" />
            </NavLink>
            <span></span>
          </li>
          )}
      </div>
      {hoverTooltip?.title && (
        <div
          className={`fixed z-[9999] flex items-center text-xs whitespace-nowrap transition-opacity duration-200 ease-out ${isTooltipVisible ? "opacity-100" : "opacity-0"
            }`}
          style={{
            top: hoverTooltip.top,
            height: hoverTooltip.height,
            background: "var(--allowed)",
            color: "#ffffff",
            padding: "0 10px",
            borderBottom: "1px solid rgba(255, 255, 255, 0.35)",
            pointerEvents: "none",
            ...(hoverTooltip.isRTL
              ? { right: hoverTooltip.right, borderRadius: "5px 0px 0px 5px" }
              : { left: hoverTooltip.left, borderRadius: "0px 5px 5px 0px" }),
          }}
        >
          {hoverTooltip.title}
        </div>
      )}
    </div>
  );
};

export default MenuSide;
